import { render } from "./MembersAdd.vue?vue&type=template&id=1772feeb&scoped=true"
import script from "./MembersAdd.vue?vue&type=script&lang=js"
export * from "./MembersAdd.vue?vue&type=script&lang=js"

import "./MembersAdd.vue?vue&type=style&index=0&id=1772feeb&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1772feeb"]])

export default __exports__